<wchfs-form-field [class.disabled]="control?.disabled">
  <wchfs-label>{{ label | translate }}</wchfs-label>

  <app-base-single-select
    dataCy="invoice-single-select"
    [formControl]="control"
    [data]="data$ | async"
    [placeholder]="'choose-and-search' | translate"
    [config]="{
      search: true
    }"
  ></app-base-single-select>
</wchfs-form-field>
